module.exports = __webpack_public_path__ + "img/yishi7.e6d6a921.jpg";